import { render } from "./HeroiconsOutlineChevronDoubleUp.vue?vue&type=template&id=693bb7af"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDoubleUp.vue"]])

export default __exports__